import { render, staticRenderFns } from "./IdentifyCoordinates.vue.js?vue&type=template&id=77315f69&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IdentifyCoordinates.vue?vue&type=template&id=77315f69&scoped=true"
import script from "./IdentifyCoordinates.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IdentifyCoordinates.vue?vue&type=script&lang=js"
export * from "./IdentifyCoordinates.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IdentifyCoordinates.vue?vue&type=script&lang=js"
import style0 from "./IdentifyCoordinates.vue.scss?vue&type=style&index=0&id=77315f69&prod&scoped=true&lang=scss!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./IdentifyCoordinates.vue?vue&type=style&index=0&id=77315f69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77315f69",
  null
  
)

export default component.exports